// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"102":"7a01e04f","453":"98bb2bcc","678":"284e1be1"}[chunkId] + ".chunk.js";
};